/**
 * The security recommendations shown to users, in the "Security tips" dialog and on the Help Center page
 * (BSI TR-03161-2 O.Plat_8 and O.Resi_1). Each tip has the translation keys SECURITY-TIPS-<id>-TITLE and
 * SECURITY-TIPS-<id>-TEXT; each group has SECURITY-TIPS-GROUP-<id>.
 *
 *  - USE:    how to use the app and the device safely
 *  - CONFIG: how to configure the app safely
 */
export const SECURITY_TIP_GROUPS = [
    {
        id: 'USE',
        tips: [
            'DEVICE',
            'UPDATES',
            'LOGIN',
            'PASSWORD',
            'SIGNOUT',
            'LINKS',
            // 'EXPORT',
            'NETWORK',
            'ROOT',
            'EXTENSIONS',
            'CAMERA',
            'REPORT',
        ],
    },
    {
        id: 'CONFIG',
        tips: ['CONFIG-ACCESS', 'CONFIG-EMERGENCY', 'CONFIG-DEVICES', 'CONFIG-NOTIFICATIONS', 'CONFIG-DATA'],
    },
] as const;
